<app-breadcrumbs [breadcrumbs]="breadcrumbs"></app-breadcrumbs>

<div class="row">
  <div class="col-md-12 mx-auto">
    <h3>Reporte de Finanzas</h3>
  </div>
  <hr />
  <div class="row align-items-center mb-3">
    <div class="col-md-6">
      <div class="input-group">
        <select
          class="form-select ms-1"
          name="currentOfficeId"
          [(ngModel)]="currentOfficeId"
          id="currentOfficeId"
          (change)="setCurrentOffice($event)"
        >
          <option value="0" selected="selected">Selecciona sucursal</option>
          <option
            *ngFor="let office of offices"
            value="{{ office.id }}"
            selected="{ office.id == roleofficeid ? 'selected' : '' }"
          >
            {{ office.name }}
          </option>
        </select>

        <button
          class="btn btn-outline-danger ms-1"
          type="button"
          (click)="clearSearch()"
        >
          Limpiar busqueda
        </button>

        <button
          class="btn btn-outline-primary ms-1"
          type="button"
          (click)="reloadInfo()"
          placement="top"
          ngbTooltip="Refrescar informacion"
        >
          <i class="bi bi-arrow-clockwise"></i>
        </button>
      </div>
    </div>
  </div>
  <hr />

  <table class="table table-striped">
    <thead>
      <tr>
        <th class="col">Mes - Año</th>
        <th class="col">Acciones</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let row of monthYear">
        <td>{{ row.month }} - {{ row.year }}</td>
        <td>
          <div class="d-flex">
            <!-- Editar -->
            <a
              [routerLink]="['/finance/report', officeId, row.month, row.year]"
              placement="top"
              ngbTooltip="Reporte de Ventas"
              role="button"
              class="btn btn-primary"
            >
              <i class="bi bi-pencil-square"></i>
            </a>
          </div>
        </td>
      </tr>
    </tbody>
  </table>
</div>
